import { debounceTime, tap } from "rxjs";
import { AxCounter } from "../../Limestone/AxCounter/AxCounter";

export class CartEntryQuantity {

    private deleteGropuedItemsFn: (cartEntryId: string, itemsToDelete: string[]) => void;
    private createGropuedItemsFn: (cartEntryId: string, itemsToAdd: number) => void;

    public initQuantityCounters(
        deleteFn: (cartEntryId: string, itemsToDelete: string[]) => void,
        createFn: (cartEntryId: string, itemsToAdd: number) => void,
        maxItems?: number
    ) {
        this.deleteGropuedItemsFn = deleteFn;
        this.createGropuedItemsFn = createFn;
        const $counters = $('[data-counter-cartEntryID]');
        $counters.each((i, $counter) => {

            const relatedTicketsString = $counter.getAttribute('data-counter-related-tickets');
            const cartEntryId = $counter.getAttribute('data-counter-cartEntryID');
            const totalCartEntries = relatedTicketsString?.split('+') ?? [];

            let axCounter = new AxCounter();
            axCounter.Init({
                Value: totalCartEntries.length,
                Selector: $counter,
                Max: maxItems || 10,
                Min: 1,
            });
            axCounter.getSubscription()
                .pipe(
                    tap(() => $('.pop-up-cart--deleteItemBtn, .delete-position').addClass('prevent-default')),
                    debounceTime(1000),
                )
                .subscribe(currentCount => {
                    if (totalCartEntries.length > currentCount) {
                        const itemsToDelete = totalCartEntries.slice(currentCount - totalCartEntries.length);
                        this.deleteGropuedItemsFn(cartEntryId, itemsToDelete);
                    } else if (totalCartEntries.length < currentCount) {
                        this.createGropuedItemsFn(cartEntryId, (currentCount - totalCartEntries.length))
                    } else {
                        $('.pop-up-cart--deleteItemBtn, .delete-position').removeClass('prevent-default');
                    }
                });
        });
    }
}